import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import Asset from '../../requests/apa/Asset';
import AnalyticsDimensionSingleton from '../Header/AnalyticsDimensionSingleton';
import TrackerManager from '../../utils/TrackerManager';
import './styles/modalReintento.scss';
import Metadata from '../../requests/apa/Metadata';
import Utils, { setRandomTimeout } from '../../utils/Utils';
import { Resilence } from 'src/AAF/Resilence/main';
import store from 'src/store';
import { showModal } from '../../actions/modal';

interface IProps {
  assetIcon?: string;
}

const ModalFailFilterTalents = (props: IProps) => {
    const validateAssetIcon = props.assetIcon ? props.assetIcon : 'alert_warning_generic_icon';
    const defaultAsset = Asset.get(`${validateAssetIcon}`, '');

    const content = Translator.get(
        'contents_withoutResults_talents_message_label',
        'Por el momento no pudimos completar la acción. Por favor intenta más tarde.'
    );
    const title = Translator.get(
        'contents_withoutResults_talents_description_label',
        'Estamos experimentando fallas'
    );
    const messageButton = Translator.get('contents_withoutResults_talents_option_button_close', 'ACEPTAR');

    const handleCloseModal = () => {
        store.dispatch(
            showModal({
                modalType: 'HIDE_MODAL',
                modalProps: {},
            })
        );
    };

    const p = {
        className: 'retry-new',
        asset: defaultAsset,
        title: title,
        content,
        buttons: [
            {
                content: messageButton,
                props: { onClick: () => handleCloseModal() },
            },
        ],
        onClose: handleCloseModal,
        aafNewStyle: true,
        showLogo: true,
        buttonsAlign: 'vertical',
    };

    return <ModalWrapper {...p} />;
};
export default withOnClose(ModalFailFilterTalents);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalFailFilterTalents.tsx